import * as types from './mutation-types'

export default {
  [types.FILL_ORDERS](state, payload = { orders }) {
    state.orders = payload.orders
  },  
  [types.TOGGLE_SIDEBAR](state, payload = { sidebar_opened }) {
    state.sidebar_opened = payload.sidebar_opened
  },
  [types.SET_SELECTED_ORDERS](state, payload = { selectedOrders }) {
    state.selectedOrders = payload.selectedOrders
  },
  [types.FILL_OCCURRENCES](state, payload = { occurrences }) {
    state.occurrences = payload.occurrences
    state.cache.occurrencesLoaded = true
  },
  [types.APPEND_ORDERS](state, payload = { orders }) {
    state.orders = [...state.orders, ...payload.orders]
    state.pagination.totalLoaded = state.orders.length
  },
  [types.SET_PAGINATION](state, payload = { pagination }) {
    state.pagination = {
      ...state.pagination,
      ...payload.pagination
    }
  },
  [types.SET_FILTER_DATE](state, payload) {
    state.activeFilterDate = {
      ...state.activeFilterDate,
      ...payload
    }
  },
  [types.RESET_ORDERS](state) {
    state.orders = []
    state.pagination = {
      limit: 10,
      offset: 0,
      hasMore: true,
      isLoadingMore: false,
      totalLoaded: 0
    },    
    state.cache.ordersLoaded = false
  },
  [types.SET_CACHE_LOADED](state, payload = { loaded }) {
    state.cache.ordersLoaded = payload.loaded  
  },  
}